import React from "react";
import { Link } from "react-router-dom";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import heroImage from "../Media/events/past/edith.jpg";
import "./Topic.scss";

const International = () => {
  return (
    <>
      <NavBar />
      <main className="topic">
        <header className="topic__hero">
          <div className="container topic__heroInner">
            <div className="topic__heroText">
              <span className="eyebrow">International Education</span>
              <h1 className="section-heading">International Education</h1>
              <p className="lede">
                Industry-specific courses, webinars, and more.
              </p>
              <Link to="/membership" className="btn btn--filled">Join Us Today</Link>
            </div>
            <div className="topic__heroImage">
              <img src={heroImage} alt="Edith Cowan University discussions on Australian education in Egypt" />
            </div>
          </div>
        </header>

        <section className="topic__body">
          <div className="container">
            <p className="lede">
              ANZEG offers educational courses and webinars that members can
              attend. ANZEG hosts specialized courses, ranging from
              industry-specific insights to broader topics like leadership,
              intercultural dialogue, digital marketing, fintech,
              agriculture, insurance, banking and recruitment. ANZEG also
              offers mental well-being in the workplace, which is why our
              chamber is seen as a thought leader. Collaborations with
              recognized industry experts, academic institutions and
              influencers further elevate our appeal. Professional
              development programs are also a staple of our organization in
              different areas of industry and culture &amp; art.
            </p>
          </div>
        </section>

        <section className="topic__about">
          <div className="container">
            <span className="eyebrow">About Us</span>
            <h2 className="section-heading section-heading--sm">
              Access to Financial Support
            </h2>
            <p className="lede">
              ANZEG has access to financial support mechanisms facilitated by
              governmental and non-governmental bodies. Depending on the
              region and the chamber's objectives, it may be eligible for
              local government grants or funding programs designed to
              support individuals and communities.
            </p>
          </div>
        </section>

        <section className="topic__contact">
          <div className="container">
            <h2 className="section-heading section-heading--sm">Get in Touch</h2>
            <p className="lede">
              We'd love to hear from you! Reach out to us for more
              information or collaboration opportunities.
            </p>
            <a href="mailto:info@anzeginstitute.org" className="btn btn--filled">Contact Us</a>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default International;
